import * as constants from "./constants";

const initialState = {
  allReportDetail: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
  search: {},
};
const reportDetailReducer = (state = initialState, action) => {
  console.log("Received data in reducer:", action); 
  switch (action.type) {
    case constants.FETCH_REPORT_DETAIL:
      return { ...state, fetchingLoading: true };

  case constants.FETCH_REPORT_DETAIL_SUCCESS:
  return {
    ...state,
    fetchingLoading: false,
    // allReportDetail: Array.isArray(action.payload) ? action.payload : [],
    allReportDetail: action.payload, 
  };

    case constants.FETCH_REPORT_DETAIL_ERROR:
      return { ...state, fetchingLoading: false };

  
    case constants.CREATE_REPORT_DETAIL:
      return { ...state, updateLoading: true };

  
    case constants.CREATE_REPORT_DETAIL_SUCCESS:
  return {
    ...state,
    updateLoading: false,
    allReportDetail: [action.payload, ...state.allReportDetail],
    isAdding: false,
  };

    // case constants.CREATE_REPORT_DETAIL_ERROR:
    //   return { ...state, updateLoading: false };

case constants.CREATE_REPORT_DETAIL_ERROR:
  return { ...state, updateLoading: false, isAdding: false };

    case constants.UPDATE_REPORT_DETAIL:
      return { ...state, updateLoading: true };

    case constants.UPDATE_REPORT_DETAIL_SUCCESS:
      
      return {
        ...state,
        allReportDetail: state.allReportDetail.map((el) =>
          el._id === action.data._id ? { ...el, ...action.data } : el
        ),
        updateLoading: false,
      };

    case constants.UPDATE_REPORT_DETAIL_ERROR:
      return { ...state, updateLoading: false };


    case constants.IS_ADDING_UPDATE:
      return { ...state, isAdding: action.data };

    // case constants.SET_REPORT_DETAIL_MANAGER_STATE:
    //   const newState = { ...state, ...action.data };
    //   localStorage.setItem(
    //     "reportDetailManagerState",
    //     JSON.stringify(newState)
    //   );
    //   return newState;

    default:
      return state;
  }
};
export default reportDetailReducer;
